import { memo } from 'react';
import useBrowserEvents from '../../hooks/useBrowserEvents';

const BrowserEventsTracker = () => {
  useBrowserEvents();
  return <></>;
};

export default memo(BrowserEventsTracker);
